export type ChangeDirection = 'up' | 'down' | 'flat';

/**
 * How a number compares with the one before it. `percent` is null when there
 * is nothing to compare against, which is different from no change.
 */
export interface Change {
  percent: number | null;
  direction: ChangeDirection;
}

/**
 * The percentage change from `previous` to `current`.
 *
 * A previous number of zero has no percentage - any rise from nothing is
 * infinitely large - so it is reported as null and the card says there is no
 * previous data, rather than dividing by zero or inventing "100%".
 */
export function percentChange(current: number, previous: number): Change {
  if (previous === 0) return { percent: null, direction: 'flat' };
  if (current === previous) return { percent: 0, direction: 'flat' };

  const percent = ((current - previous) / previous) * 100;
  return { percent, direction: percent > 0 ? 'up' : 'down' };
}
